import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import moment from 'moment';
import {DatePickerComponent, IDatePickerConfig} from 'ng2-date-picker';
import {NGXLogger} from 'ngx-logger';
import {RouteId} from 'src/app/enums/env/routes-id-enum';
import {DateKey, FiltersKey} from 'src/app/enums/search-key.enum';
import {CalculationFunction} from 'src/app/enums/stations/calculation-function';
import {FilterValue} from 'src/app/interfaces/filtres/filter-interface';
import {SearchService} from 'src/app/modules/search/services/search.service';
import {DateStartEndModel} from '../models/datesStartEndModel';
import {preSelectionModel} from '../models/preSelectionModel';
import {PreselectionDatePickerType} from './enums/preselection-date-picker-type';
import {CalculationFunctionType, DataTimeStepType, GraphConfigurationData} from 'src/swagger-gen/web-secured/models';


@Component({
    selector: '.date-time-picker',
    templateUrl: './dateTime-picker.component.html',
    styleUrls: ['./dateTime-picker.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateTimePickerComponent implements AfterViewInit {

    //envoyer deux parametre, en Input dateStart dateEnd
    @Input() maxIntervalDays = 92;
    @Input() preSelectionRange = true;
    @Input() configuredPreselectionId: PreselectionDatePickerType = PreselectionDatePickerType.LASTWEEK;
    @Input() graphChoicesStepEnabled = false;
    @Input() customDates;
    @Input() filterList: FilterValue<DateKey>[] = [];
    @Input() routeId: RouteId;
    @Output() onApply: EventEmitter<DateStartEndModel> = new EventEmitter<DateStartEndModel>();
    @Input() updateInfos: GraphConfigurationData;

    @ViewChild('selectFormatedDate') elem: ElementRef;
    /**
     * Current application language
     */
    language: 'fr' | 'en' = 'fr';

    /* DATES */
    /**
     * Date format to display depending of language
     */
    dateFormat: string;
    errorDate = '';

    preselections: Array<preSelectionModel> = [];

    // ranges, steps
    CALCULATION_FUNCTION = CalculationFunction;
    stepTypes = Object.values(DataTimeStepType).filter(o => o === DataTimeStepType.HOUR || o === DataTimeStepType.DAY || o === DataTimeStepType.MINUTE);
    calculationTypes = Object.values(CalculationFunction).filter(o => o === CalculationFunction.AVERAGE || o === CalculationFunction.RAW);
    currentStepType: DataTimeStepType = DataTimeStepType.MINUTE;
    currentCalculation: CalculationFunction | CalculationFunctionType = CalculationFunction.AVERAGE;
    currentStepRange = 1;
    queryPDateValid: boolean = false;
    routePath: string = this.router.routerState.snapshot.root.firstChild.routeConfig.path;
    endDateFilter = moment();
    startDateFilter = this.endDateFilter.clone().subtract(this.maxIntervalDays, 'days');
    maxIntervalMs: number;
    datePickerConfig: IDatePickerConfig = {
        disableKeypress: false,
        format: 'DD/MM/YYYY HH:mm:ss',
        monthFormat: 'MMMM, YYYY',
        firstDayOfWeek: 'mo',
        showTwentyFourHours: true,
        showSeconds: true,
        showGoToCurrent: true,
        showNearMonthDays: false,
        hideOnOutsideClick: true,
        enableMonthSelector: true,
        allowMultiSelect: false,
    };
    startDatePickerConfig = this.datePickerConfig;
    endDatePickerConfig = this.datePickerConfig;
    @ViewChild('startDatePicker', {static: true}) startDatePicker: DatePickerComponent;

    // @ViewChild('endDatePicker', {static: true }) endDatePicker: DatePickerComponent;

    constructor(private logger: NGXLogger,
                private elementRef: ElementRef,
                private cdref: ChangeDetectorRef,
                private searchService: SearchService,
                private router: Router,) {
    }

    ngOnChanges(change: SimpleChanges) {

        if (change.filterList) {
            const startDate = this.filterList.find(elm => elm.key == DateKey.DATESTART) ? this.filterList.find(elm => elm.key == DateKey.DATESTART).value : '';
            const endDate = this.filterList.find(elm => elm.key == DateKey.DATEEND) ? this.filterList.find(elm => elm.key == DateKey.DATEEND).value : '';
            if (moment(startDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid() && moment(endDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid()) {
                this.startDateFilter = moment(startDate);
                this.endDateFilter = moment(endDate);
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.customDates) {
            this.endDateFilter = moment(this.customDates.endDate);
            this.startDateFilter = this.endDateFilter.clone().subtract(7, 'days');
        }
        this.intialize();

    }

    intialize() {
        this.moveCalendarTo();
        const intervalMonth = moment.duration(this.maxIntervalDays, 'days');
        // this.maxIntervalMs = intervalMonth.asMilliseconds() + 3600;
        this.maxIntervalMs = intervalMonth.asMilliseconds() + 3600;
        this.blockInvalidCharsInDatepicker();
        if (this.updateInfos) {
            this.patchFields();
        }
        this.intializePreSelectionItem();
        this.applySelection();
    }

    patchFields() {
        this.configuredPreselectionId = this.updateInfos.preselectionDateType.toLocaleLowerCase() as PreselectionDatePickerType;
        if (this.configuredPreselectionId === PreselectionDatePickerType.CUSTOM) {
            this.startDateFilter = moment(this.updateInfos.startDateTime);
            this.endDateFilter = moment(this.updateInfos.endDateTime);
        }
        this.currentStepType = this.updateInfos.dataTimeStepType;
        this.currentStepRange = this.updateInfos.dataTimeStepRange;
        this.currentCalculation = this.updateInfos.calculationFunction as CalculationFunctionType;
    }

    // ngAfterViewChecked() {
    // if(this.customDates)
    // this.endDateFilter = moment(this.customDates.endDate);
    // this.startDateFilter = this.endDateFilter.clone().subtract(7, 'days');
    // this.cdref.detectChanges();
    // }
    intializePreSelectionItem() {
        this.preselections = [];
        if (this.maxIntervalDays > 0) {
            const today: preSelectionModel = {
                id: PreselectionDatePickerType.TODAY,
                name: 'Aujourd\'hui',
            };
            this.preselections.push(today);
        }
        if (this.maxIntervalDays >= 1) {
            const last24hours: preSelectionModel = {
                id: PreselectionDatePickerType.LAST_24_HOURS,
                name: 'Dernières 24 heures',
            };
            this.preselections.push(last24hours);
        }
        if (this.maxIntervalDays >= 7) {
            const lastweek: preSelectionModel = {
                id: PreselectionDatePickerType.LASTWEEK,
                name: 'Les 7 derniers jours',
            };
            this.preselections.push(lastweek);
        }
        if (this.maxIntervalDays >= 30) {
            const lastmonth: preSelectionModel = {
                id: PreselectionDatePickerType.LAST_MONTH,
                name: 'Les 30 derniers jours'
            };
            this.preselections.push(lastmonth);
        }
        if (this.maxIntervalDays >= 92) {
            const last3month: preSelectionModel = {
                id: PreselectionDatePickerType.LAST_3_MONTH,
                name: 'Les 3 derniers mois',
            };
            this.preselections.push(last3month);
        }
        if (this.maxIntervalDays > 92) {
            const lastmonth: preSelectionModel = {
                id: PreselectionDatePickerType.LAST_CUSTOM_DAYS,
                name: 'Les ' + this.maxIntervalDays + ' derniers jours'
            };
            this.preselections.push(lastmonth);
        }
        this.preselections.push({id: PreselectionDatePickerType.CUSTOM, name: 'Personnalisé'});


        if (!this.queryPDateValid) {
            this.selectDefaultPreSelection();
        }
    }

    // Select the default option automatically
    // faut que je modifie ici pour mettre personnaliser
    selectDefaultPreSelection() {
        let defaultPreselection: preSelectionModel;
        const filterSession = this.searchService.getSearchByRouteId(this.routeId);
        // vérifie si un filtre existe sur les dates
        if (filterSession) {
            const filterDateStart = filterSession.params.find(elm => elm.key == FiltersKey.DATESTART);
            const filterDateEnd = filterSession.params.find(elm => elm.key == FiltersKey.DATEEND);
            //
            if (filterDateStart && filterDateEnd) {

                this.startDateFilter = moment(filterDateStart.value);
                this.endDateFilter = moment(filterDateEnd.value);
                let intervalDate = this.endDateFilter.diff(this.startDateFilter, 'days');
                // permet de récupérer la nom de la sélection grâce à la différence de date
                this.configuredPreselectionId = this.selectDatePickerWithDates(intervalDate);
                defaultPreselection = this.preselections.find(p => p.id === this.configuredPreselectionId);
                defaultPreselection.selected = true;
                this.errorDate = '';
                this.moveCalendarTo();

            } else {
                const found = this.preselections.find(p => p.id === this.configuredPreselectionId);
                if (found) {
                    defaultPreselection = found;
                } else {
                    defaultPreselection = this.preselections[0];
                }

                defaultPreselection.selected = true;
                this.onChangePreSelection(defaultPreselection.id);
            }
        } else {
            const found = this.preselections.find(p => p.id === this.configuredPreselectionId);
            if (found) {
                defaultPreselection = found;
            } else {
                defaultPreselection = this.preselections[0];
            }

            defaultPreselection.selected = true;
            this.onChangePreSelection(defaultPreselection.id);
        }


    }

    selectDatePickerWithDates(intervalDates): PreselectionDatePickerType {
        var select: PreselectionDatePickerType;
        if (intervalDates == 0) {
            select = PreselectionDatePickerType.TODAY;
        } else if (intervalDates == 1) {
            select = PreselectionDatePickerType.LAST_24_HOURS;
        } else if (intervalDates == 7) {
            select = PreselectionDatePickerType.LASTWEEK;
        } else if (intervalDates >= 28 && intervalDates <= 31) {
            select = PreselectionDatePickerType.LAST_MONTH;
        } else if (intervalDates >= 89 && intervalDates <= 92) {
            select = PreselectionDatePickerType.LAST_3_MONTH;
        } else {
            select = PreselectionDatePickerType.CUSTOM;
        }
        return select;

    }

    moveCalendarTo() {
        // Set startDatePicker to display the start date.
        // NB: must format, otherwise bug in DatePicker library (months are not translated)
        this.startDatePicker.api.moveCalendarTo(this.startDateFilter.format(this.datePickerConfig.format));
        this.cdref.detectChanges();
    }

    // Set Custom option in select preSelection
    setCustomValueOnPreSelect() {
        const preSelection = <HTMLInputElement>document.getElementById('selectFormatedDate');
        if (preSelection) {
            preSelection.value = 'custom';
        }
    }

    /**
     * When a date is selected in startDatePicker
     * @param event selected date
     */
    onStartDatePickerSelect(event: any): void {
        if (this.preSelectionRange) {
            this.setCustomValueOnPreSelect();
        }
        this.errorDate = this.testDates();
    }

    /**
     * When a date is selected in endDatePicker
     * @param event selected date
     */
    onEndDatePickerSelect(event: any): void {
        if (this.preSelectionRange) {
            this.setCustomValueOnPreSelect();
        }
        this.errorDate = this.testDates();
    }

    testDates(): string {
        this.errorDate = '';

        const diffDate = this.endDateFilter.diff(this.startDateFilter);
        if (diffDate < 0) {
            return 'La date de début ne peut pas être postérieure à celle de fin';
        }

        if (diffDate > this.maxIntervalMs) {
            return 'L\'intervalle entre les 2 dates ne doit pas dépasser ' + Math.round(this.maxIntervalDays / 30) + ' mois (' + this.maxIntervalDays + ' jours)';
        }

        return '';
    }

    blockInvalidCharsInDatepicker() {
        const inputs = this.elementRef.nativeElement.querySelectorAll('input.dp-picker-input');
        inputs.forEach(b => {
            b.addEventListener('keypress', this.formatDatepickerEntry.bind(this));
        });
    }

    formatDatepickerEntry(event) {
        this.logger.trace('inputChar', event.key);
        const pattern = /[0-9\/: ]/;
        if (!pattern.test(event.key)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    }

    onChangePreSelection(value: PreselectionDatePickerType) {
        switch (value) {
            case PreselectionDatePickerType.TODAY:
                this.errorDate = '';
                this.endDateFilter = moment();
                this.startDateFilter = this.endDateFilter.clone().subtract(0, 'days').startOf('day');
                this.moveCalendarTo();
                break;
            case PreselectionDatePickerType.LAST_24_HOURS:
                this.errorDate = '';
                this.endDateFilter = moment();
                this.startDateFilter = this.endDateFilter.clone().subtract(24, 'hours').startOf('hour');
                this.moveCalendarTo();
                break;
            case PreselectionDatePickerType.LASTWEEK:
                this.errorDate = '';
                this.endDateFilter = moment();
                this.startDateFilter = this.endDateFilter.clone().subtract(7, 'days');
                this.moveCalendarTo();
                break;
            case PreselectionDatePickerType.LAST_MONTH:
                this.errorDate = '';
                this.endDateFilter = moment();
                this.startDateFilter = this.endDateFilter.clone().subtract(1, 'month');
                this.moveCalendarTo();
                break;
            case PreselectionDatePickerType.LAST_3_MONTH:
                this.errorDate = '';
                this.endDateFilter = moment();
                this.startDateFilter = this.endDateFilter.clone().subtract(3, 'month');
                this.moveCalendarTo();
                break;
            case PreselectionDatePickerType.LAST_CUSTOM_DAYS:
                this.errorDate = '';
                this.endDateFilter = moment();
                this.startDateFilter = this.endDateFilter.clone().subtract(this.maxIntervalDays, 'days');
                this.moveCalendarTo();
                break;
            case PreselectionDatePickerType.CUSTOM:
                if (this.customDates) {
                    this.endDateFilter = moment(this.customDates.endDate);
                    this.startDateFilter = this.endDateFilter.clone().subtract(7, 'days');
                }
                if (this.updateInfos) {
                    this.startDateFilter = moment(this.updateInfos.startDateTime);
                    this.endDateFilter = moment(this.updateInfos.endDateTime);
                }
                this.moveCalendarTo();
                break;
        }
    }


    applySelection() {
        const resultDate = new DateStartEndModel;
        resultDate.dateStart = this.startDateFilter.toISOString();
        resultDate.dateEnd = this.endDateFilter.toISOString();
        resultDate.preSelectionType = this.elem.nativeElement.value;
        if (this.graphChoicesStepEnabled) {
            resultDate.stepType = this.currentStepType;
            resultDate.stepRange = this.currentStepRange;
            resultDate.calculation = this.currentCalculation as CalculationFunction;
        }
        this.onApply.emit(resultDate);
    }

}
